import React, { createContext, useContext, useEffect, useState } from "react";

const CountryContext = createContext();

const countries = {
  india: {
    name: "India",
    flag: "🇮🇳",
    currency: "INR",
    symbol: "₹",
    locale: "en-IN",
    language: "English",
    rate: 112,
  },

  uk: {
    name: "United Kingdom",
    flag: "🇬🇧",
    currency: "GBP",
    symbol: "£",
    locale: "en-GB",
    language: "English",
    rate: 1,
  },

  usa: {
    name: "United States",
    flag: "🇺🇸",
    currency: "USD",
    symbol: "$",
    locale: "en-US",
    language: "English",
    rate: 1.35,
  },

  france: {
    name: "France",
    flag: "🇫🇷",
    currency: "EUR",
    symbol: "€",
    locale: "fr-FR",
    language: "French",
    rate: 1.16,
  },

  germany: {
    name: "Germany",
    flag: "🇩🇪",
    currency: "EUR",
    symbol: "€",
    locale: "de-DE",
    language: "German",
    rate: 1.16,
  },

  italy: {
    name: "Italy",
    flag: "🇮🇹",
    currency: "EUR",
    symbol: "€",
    locale: "it-IT",
    language: "Italian",
    rate: 1.16,
  },

  spain: {
    name: "Spain",
    flag: "🇪🇸",
    currency: "EUR",
    symbol: "€",
    locale: "es-ES",
    language: "Spanish",
    rate: 1.16,
  },

  australia: {
    name: "Australia",
    flag: "🇦🇺",
    currency: "AUD",
    symbol: "A$",
    locale: "en-AU",
    language: "English",
    rate: 2.08,
  },

  canada: {
    name: "Canada",
    flag: "🇨🇦",
    currency: "CAD",
    symbol: "C$",
    locale: "en-CA",
    language: "English",
    rate: 1.86,
  },

  uae: {
    name: "United Arab Emirates",
    flag: "🇦🇪",
    currency: "AED",
    symbol: "د.إ",
    locale: "en-AE",
    language: "English",
    rate: 4.96,
  },

  southafrica: {
    name: "South Africa",
    flag: "🇿🇦",
    currency: "ZAR",
    symbol: "R",
    locale: "en-ZA",
    language: "English",
    rate: 24,
  },

  nigeria: {
    name: "Nigeria",
    flag: "🇳🇬",
    currency: "NGN",
    symbol: "₦",
    locale: "en-NG",
    language: "English",
    rate: 2050,
  },

  switzerland: {
    name: "Switzerland",
    flag: "🇨🇭",
    currency: "CHF",
    symbol: "CHF",
    locale: "de-CH",
    language: "German",
    rate: 1.02,
  },
};

export const CountryProvider = ({ children }) => {
  // Default country = United Kingdom
  const [country, setCountry] = useState("uk");

  // Save selected country
  useEffect(() => {
    localStorage.setItem("selectedCountry", country);
  }, [country]);

  // Current country details
  const currentCountry = countries[country] || countries.uk;

  // Convert GBP base price into selected country's currency
  const convertPrice = (gbpPrice) => {
    const numericPrice = Number(
      String(gbpPrice).replace(/[£₹$€]/g, "").trim()
    );

    if (isNaN(numericPrice)) {
      return 0;
    }

    return numericPrice * currentCountry.rate;
  };

  // Format price according to selected country
  const formatPrice = (gbpPrice) => {
    const convertedPrice = convertPrice(gbpPrice);

    return new Intl.NumberFormat(currentCountry.locale, {
      style: "currency",
      currency: currentCountry.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(convertedPrice);
  };

  return (
    <CountryContext.Provider
      value={{
        country,
        setCountry,
        countries,
        currentCountry,
        convertPrice,
        formatPrice,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => useContext(CountryContext);
